import { TiHtml5 } from "react-icons/ti";
import { BsFiletypeCss, BsFiletypeSql, BsFiletypeJson } from "react-icons/bs";
import {
  FaBootstrap,
  FaReact,
  FaNode,
  FaGithub,
  FaPython,
  FaJava,
} from "react-icons/fa6";
import { TbBrandJavascript } from "react-icons/tb";
import { LuSettings } from "react-icons/lu";
import {
  SiJquery,
  SiExpress,
  SiMongodb,
  SiMui,
  SiMysql,
  SiHibernate,
  SiSpring,
  SiSpringboot,
} from "react-icons/si";

export const Techstacklist = [
  {
    _id: 1,
    name: "HTML",
    icon: TiHtml5,
    url: "https://www.udemy.com/certificate/UC-77025406-2261-469d-88b1-0eec108f85de/",
  },
  {
    _id: 2,
    name: "CSS",
    icon: BsFiletypeCss,
    url: "https://www.udemy.com/certificate/UC-77025406-2261-469d-88b1-0eec108f85de/",
  },
  {
    _id: 3,
    name: "Bootstrap",
    icon: FaBootstrap,
    url: "https://www.udemy.com/certificate/UC-77025406-2261-469d-88b1-0eec108f85de/",
  },
  {
    _id: 4,
    name: "JavaScript",
    icon: TbBrandJavascript,
    url: "https://www.udemy.com/certificate/UC-77025406-2261-469d-88b1-0eec108f85de/",
  },
  {
    _id: 5,
    name: "jQuery",
    icon: SiJquery,
    url: "https://www.udemy.com/certificate/UC-77025406-2261-469d-88b1-0eec108f85de/",
  },
  {
    _id: 6,
    name: "React.js",
    icon: FaReact,
    url: "https://www.udemy.com/certificate/UC-77025406-2261-469d-88b1-0eec108f85de/",
  },
  {
    _id: 7,
    name: "Material UI",
    icon: SiMui,
    url: "https://www.udemy.com/certificate/UC-77025406-2261-469d-88b1-0eec108f85de/",
  },
  {
    _id: 8,
    name: "Node.js",
    icon: FaNode,
    url: "https://www.udemy.com/certificate/UC-77025406-2261-469d-88b1-0eec108f85de/",
  },
  {
    _id: 9,
    name: "Express.js",
    icon: SiExpress,
    url: "https://www.udemy.com/certificate/UC-77025406-2261-469d-88b1-0eec108f85de/",
  },
  {
    _id: 10,
    name: "Mongo DB",
    icon: SiMongodb,
    url: "https://www.udemy.com/certificate/UC-77025406-2261-469d-88b1-0eec108f85de/",
  },
  {
    _id: 11,
    name: "Rest API",
    icon: LuSettings,
    url: "https://www.udemy.com/certificate/UC-77025406-2261-469d-88b1-0eec108f85de/",
  },
  {
    _id: 12,
    name: "SQL",
    icon: BsFiletypeSql,
    url: "https://courses.cognitiveclass.ai/certificates/208f24d85cfb47aabc278f09c6bb19fd",
  },
  {
    _id: 13,
    name: "Python",
    icon: FaPython,
    url: "https://drive.google.com/file/d/1GmucjvjuAdVKGqZKklYy37JZb_Le1dYh/view?usp=drivesdk",
  },
  {
    _id: 14,
    name: "Git & GitHub",
    icon: FaGithub,
    url: "https://drive.google.com/file/d/1k3EPF3e2ZfUaN7wgInbMlyI5LzvxrFTc/view?usp=drive_link",
  },
  {
    _id: 15,
    name: "Java",
    icon: FaJava,
    url: "https://drive.google.com/file/d/1qngQARXDApnnUCeX-vT__5IQiRmquhhM/view?usp=drive_link",
  },
  {
    _id: 16,
    name: "MySql",
    icon: SiMysql,
    url: "https://drive.google.com/file/d/1qngQARXDApnnUCeX-vT__5IQiRmquhhM/view?usp=drive_link",
  },
  {
    _id: 17,
    name: "JDBC",
    icon: FaJava,
    url: "https://drive.google.com/file/d/1qngQARXDApnnUCeX-vT__5IQiRmquhhM/view?usp=drive_link",
  },
  {
    _id: 18,
    name: "Hibernate",
    icon: SiHibernate,
    url: "https://drive.google.com/file/d/1qngQARXDApnnUCeX-vT__5IQiRmquhhM/view?usp=drive_link",
  },
  {
    _id: 19,
    name: "Spring",
    icon: SiSpring,
    url: "https://drive.google.com/file/d/1qngQARXDApnnUCeX-vT__5IQiRmquhhM/view?usp=drive_link",
  },
  {
    _id: 120,
    name: "SpringBoot",
    icon: SiSpringboot,
    url: "https://drive.google.com/file/d/1qngQARXDApnnUCeX-vT__5IQiRmquhhM/view?usp=drive_link",
  },
  {
    _id: 21,
    name: "Spring MVC",
    icon: SiSpring,
    url: "https://drive.google.com/file/d/1qngQARXDApnnUCeX-vT__5IQiRmquhhM/view?usp=drive_link",
  },
  {
    _id: 22,
    name: "JSON",
    icon: BsFiletypeJson,
    url: "https://www.udemy.com/certificate/UC-77025406-2261-469d-88b1-0eec108f85de/",
  },
];
